import { render, staticRenderFns } from "./DriverDetails.vue?vue&type=template&id=8a487d3a&scoped=true&"
import script from "./DriverDetails.vue?vue&type=script&lang=js&"
export * from "./DriverDetails.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetails.vue?vue&type=style&index=0&id=8a487d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a487d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a487d3a')) {
      api.createRecord('8a487d3a', component.options)
    } else {
      api.reload('8a487d3a', component.options)
    }
    module.hot.accept("./DriverDetails.vue?vue&type=template&id=8a487d3a&scoped=true&", function () {
      api.rerender('8a487d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/components/DriverDetails.vue"
export default component.exports